"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIBetaButton = _interopRequireDefault(require("UIComponents/button/UIBetaButton/UIBetaButton"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIOptConstants = require("ui-addon-opt/constants/UIOptConstants");

var _OptActions = require("ui-addon-opt/state/OptActions");

var Optin = function Optin(_ref) {
  var dispatch = _ref.dispatch,
      learnMore = _ref.learnMore,
      onLearnMoreClick = _ref.onLearnMoreClick,
      onView = _ref.onView,
      optInButtonText = _ref.optInButtonText,
      showIcon = _ref.showIcon,
      showHubOptin = _ref.showHubOptin,
      showUserOptin = _ref.showUserOptin;
  return _react.default.createElement(_UIDropdown.default, {
    Button: _UIBetaButton.default,
    buttonText: optInButtonText,
    icon: showIcon ? undefined : 'none',
    onOpenComplete: onView,
    style: _UIOptConstants.POSITIONING
  }, _react.default.createElement(_UIList.default, null, showUserOptin && _react.default.createElement(_UIButton.default, {
    onClick: function onClick() {
      return dispatch({
        type: _OptActions.ACTION_USER_OPT_IN
      });
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optin.options.userOptin"
  })), showHubOptin && _react.default.createElement(_UIButton.default, {
    onClick: function onClick() {
      return dispatch({
        type: _OptActions.ACTION_HUB_OPT_IN
      });
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optin.options.hubOptin"
  })), learnMore && _react.default.createElement(_UIButton.default, {
    href: learnMore.url,
    onClick: onLearnMoreClick,
    target: "_blank"
  }, learnMore.text), _react.default.createElement(_UIButton.default, {
    onClick: function onClick() {
      return dispatch({
        type: _OptActions.ACTION_REJECT
      });
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optin.options.reject"
  }))));
};

Optin.propTypes = {
  dispatch: _propTypes.default.func.isRequired,
  learnMore: _propTypes.default.shape({
    text: _propTypes.default.node.isRequired,
    url: _propTypes.default.string.isRequired
  }),
  onLearnMoreClick: _propTypes.default.func.isRequired,
  onView: _propTypes.default.func,
  optInButtonText: _propTypes.default.node.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  showHubOptin: _propTypes.default.bool.isRequired,
  showUserOptin: _propTypes.default.bool.isRequired
};
Optin.defaultProps = {
  onLearnMoreClick: _emptyFunction.default,
  onView: _emptyFunction.default,
  optInButtonText: _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-opt.optin.label"
  }),
  showHubOptin: false,
  showUserOptin: true,
  showIcon: true
};
var _default = Optin;
exports.default = _default;
module.exports = exports.default;